// imports
import React from 'react';
import { ICON, IMAGE } from '../../../../assets';
import { Region } from '../../../../common/types';

// exports
export default function EmptyQuest(props: { placeholder: Region }): JSX.Element {
  const { placeholder } = props;
  return (
    <div className="dv-content">
      <div className="dv-title">
        <div className="heading">
          <img src={IMAGE.HERO_TITLE_MOTIF} alt="Left Motif" />
          <span>{placeholder.name}</span>
          <img className="right-motif" src={IMAGE.HERO_TITLE_MOTIF} alt="Right Motif" />
        </div>
      </div>
      <div className="main-section empty">
        <p className="quest-description">{placeholder.description}</p>
        <img src={ICON.MAP_CAMPAIGN_QUEST_PIN} alt="quest_placeholder" />
      </div>
    </div>
  );
}
